<template>
    <div
        style="height: 56px;"
        :style="fullWidth ? '' : `width: ${picture_width ? picture_width : '56'}px`"
        :class="$vuetify.breakpoint.xlOnly ? '' : 'd-flex'"
    >
        <v-img
            v-if="!logo_url && app.name === APP_STORE_APP_TYPES.COMPANY"
            :max-width="picture_width ? picture_width : '108px'"
            :style="isAppDialog ? 'position: relative;' : ''"
            contain
            :src="require('../../assets/app-company.svg')"
        >
        </v-img>
        <v-avatar
            v-else-if="!logo_url"
            :class="avatar_class ? avatar_class : 'app-store-avatar'"
            size="56"
            :style="avatar_style ? avatar_style : { 'borderRadius': '4px', 'z-index': 2 }"
        >
            <v-img
                :max-width="picture_width ? picture_width : '29px'"
                contain
                :src="require('../../assets/uku-icon.svg')"
            >
            </v-img>
        </v-avatar>
        <v-img
            v-else
            :max-width="picture_width ? picture_width : '86px'"
            :style="isAppDialog ? 'position: relative;' : ''"
            contain
            class="w-100"
            :class="$vuetify.breakpoint.xlOnly && app.type === 'integration' ? 'mt-1' : ''"
            :src="app.name === APP_STORE_APP_TYPES.COMPANY ? logo_url : require( '../../assets/' + logo_url)"
        >
        </v-img>
    </div>
</template>

<script>
import { getManifestData } from "@/views/AppStore/app-store-manifest";
import { computed, ref } from "@vue/composition-api";
import { APP_STORE_APP_TYPES } from "@/helpers/constants";

export default {
    name: "AppLogo",
    props: {
        app: {
            type: Object,
            required: true
        },
        isAppDialog: {
            type: Boolean,
            default: false
        },
        regionCode: {
            type: String,
            default: null
        },
        company: {
            type: Object,
            default: null
        },
        fullWidth: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        let avatar_class = ref(getManifestData(props.app.name, 'avatar_class'))
        let avatar_style = ref(getManifestData(props.app.name, 'avatar_style'))
        let picture_width = ref(getManifestData(props.app.name, 'picture_width'))

        const logo_url = computed(() => {
            if (!props.regionCode) {
                return getManifestData(props.app.name, 'logo_url', props.company)
            }

            const regionLogo = getManifestData(props.app.name, 'logo_url_region')

            if (!regionLogo) {
                return getManifestData(props.app.name, 'logo_url', props.company)
            }

            if (regionLogo[props.regionCode]) {
                return regionLogo[props.regionCode]
            }

            return getManifestData(props.app.name, 'logo_url', props.company)
        })

        return {
            logo_url,
            avatar_class,
            avatar_style,
            picture_width,
            APP_STORE_APP_TYPES
        };
    }
};
</script>
